import React,{ useEffect} from 'react';
import { JourneyRouteProps } from "./Interfaces";
import { useJourneyState } from '../context/JourneyContext';
import { StoreContext } from '../../context';
import { useContextSelector } from '@fluentui/react-context-selector';
import {  actionTypeConstants } from '../../utils';
import { setItemToSessionStorage } from '../../utils/storageUtils';

//Higher Order wrapper to pass props to route.
const JourneyRoute: React.FC<JourneyRouteProps> = ({ Route, path, passedProps, index, ...props }) => {
    const { journeyStore } = useJourneyState();
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);

    let tempProps = {
        ...props,
        ...passedProps
    }

    if (tempProps.hasOwnProperty("templateProps")) {
        //Dynamic Script Variables: If temlpateProps contains script, process for dynamic variables.
        if (tempProps.templateProps.hasOwnProperty("script")) {
            // tempProps.templateProps.script = getParseTemplateScript(passedProps.templateProps.script)
        }
        //Autonavigate to parent destination: If it has templateProps, is nextScreen missing or has a length less than 1.
        if (!tempProps.templateProps.hasOwnProperty("nextScreen") || tempProps.templateProps.nextScreen.length <= 1) {
            tempProps.parentDestination && (
                tempProps.templateProps.nextScreen = "../" + tempProps.parentDestination
            )
        }
    }

    useEffect( () => {

        dispatch({
            type: actionTypeConstants.UPDATE_HISTORY_INDEX,
            payload: {
                'historyIndex' : tempProps?.templateProps?.historyIndex || index 
            }
        });

    },[index, tempProps?.templateProps?.historyIndex]);

    useEffect( () => {
        if(tempProps?.templateProps?.isLastPage){
            setItemToSessionStorage( 'isJourneyCompleted', 1 );
        }

    },[tempProps?.templateProps?.isLastPage]);

    useEffect( () => {
        if(tempProps?.templateProps?.showBackLink){
            dispatch({
                type: actionTypeConstants.UPDATE_BACK_LINK,
                payload: {
                    'showBackLink' : tempProps?.templateProps?.showBackLink 
                }
            });
        }

    },[tempProps?.templateProps?.showBackLink]);

    return (
        <Route path={path} key={"route-" + path} index={index} {...tempProps} data={journeyStore}>
            {tempProps.children ? tempProps.children : null}
        </Route>

        // <Router path={path} key={"route-" + path} index={index} {...tempProps} data={journeyStore}>
        //     {tempProps.children ? tempProps.children : null}
        // </Router>
    )
}

export default JourneyRoute;